import React, {useEffect} from 'react';
import {Button, Col, Form, Row} from "antd";
import {useLocation} from "react-router-dom";
import {useEditQuery, useGetByIdQuery, usePostQuery} from "../../service/query/Queries";
import {EditGetById, SetInitialValue, SuccessCreateAndEdit} from "../../hooks";
import {AppLoader, FormInput} from "../../components";



const initialValueForm = {
    position: "",



}


const FloorPostEdit = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const editId = queryParams.get('editId');
    const [form] = Form.useForm();
    console.log()

    const {
        mutate: postEmployeeMutate,
        isLoading: postEmployeeLoading,
        isSuccess: postEmployeeSuccess

    } = usePostQuery()
    const {
        isLoading: editEmployeeLoading,
        data: editEmployeeData,
        refetch: editEmployeeRefetch,
        isSuccess: editEmployeeSuccess
    } = useGetByIdQuery(false, "edit-office", editId, '/employee')
    const {
        mutate: putEmployee,
        isLoading: putEmployeeLoading,
        isSuccess: putEmployeeSuccess
    } = useEditQuery()


    SuccessCreateAndEdit(postEmployeeSuccess, putEmployeeSuccess, '/employee')

    EditGetById(editEmployeeRefetch, editId)

    SetInitialValue(form, initialValueForm)


    useEffect(() => {
        if (editEmployeeSuccess) {

            const edit = {


                position: editEmployeeData?.position,
            }
            form.setFieldsValue(edit)
        }
    }, [editEmployeeData])


    const onFinish = (value) => {
        const data = {

            user_name: editEmployeeData.user_name,
            employee_id: editEmployeeData.employee_id,
            officeId: editEmployeeData.officeId._id,
            position: value.position,
        }
        if (editEmployeeData) {
            putEmployee({url: `/employee`, data: data, id: editId})
        } else {
            postEmployeeMutate({url: `/employee`, data: data});
        }
    }


    return (
        <div>
            {(postEmployeeLoading || editEmployeeLoading || putEmployeeLoading) ?
                <AppLoader/> :
                <Form
                    form={form}
                    name="basic"
                    labelCol={{
                        span: 24
                    }}
                    wrapperCol={{
                        span: 24
                    }}
                    style={{
                        maxWidth: "100%"
                    }}
                    initialValues={initialValueForm}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={20}>

                        <Col span={24}>
                            <FormInput
                                label={'Должность'}
                                name={'position'}
                            />
                        </Col>



                    </Row>
                    <Button type="primary" htmlType="submit" style={{width: "100%", marginTop: "20px"}}>
                        {editEmployeeSuccess ? 'Редактировать' : 'Создать'}
                    </Button>
                </Form>}
        </div>);
};

export default FloorPostEdit;